import { computed, ref } from "vue";
import {
	usePasswordLength,
	usePasswordRequirement,
	usePasswordLengthCheck,
	getRequirementMessage,
} from "@/ui/validation/validationRules";
import zxcvbn from "zxcvbn";

export function usePasswordValidation(passwordRef, environmentSettings) {
	const validatePassword = usePasswordRequirement();
	const passwordMessages = getRequirementMessage();
	const validateLength = usePasswordLengthCheck(
		environmentSettings.minimal_password_length
	);
	const zxcvbnChallange = computed(() => {
		return zxcvbn(passwordRef.value);
	});

	const lengthScore = usePasswordLength(
		passwordRef,
		environmentSettings.minimal_password_length
	);

	const requirementScores = computed(() => {
		const scorePerRequirement =
			40 / environmentSettings.password_requirements.length;
		return environmentSettings.password_requirements.reduce(
			(acc, requirement) => {
				if (validatePassword(requirement)(passwordRef.value)) {
					return acc + scorePerRequirement;
				}
				return acc;
			},
			0
		);
	});

	const totalScore = computed(() => {
		const rawScore = lengthScore.value + requirementScores.value;
		return Math.min(100, Math.max(0, Math.round(rawScore)));
	});

	const passwordRules = computed(() => {
		let rules = [(v) => validateLength(v)];
		rules = rules.concat(
			environmentSettings.password_requirements.map((requirement) => {
				return (v) =>
					validatePassword(requirement)(v) || passwordMessages[requirement];
			})
		);
		return rules;
	});

	return {
		totalScore,
		passwordRules,
		zxcvbnChallange,
	};
}
